import styled from "@emotion/styled";
import CrossNavigationBanner from "components/Common/CrossNavigationBanner";

export const MarketingMaterialsPageWrapper = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.secondary,
	width: "100%",
	minHeight: "100vh",
	display: "flex",
	flexDirection: "column"
}));

export const MarketingMaterialsLandingPageContent = styled.div({
	margin: "16px 24px",
	display: "flex",
	flexDirection: "column",
	gap: "16px"
});

export const MarketingMaterialsAnnouncementBanner = styled(CrossNavigationBanner)({
	margin: "16px 24px 0"
});

export const MarketingMaterialsListFiltersContainer = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	gap: "12px",
	flexWrap: "wrap",
	[theme.breakpoints.down("lg")]: {
		flexDirection: "column",
		alignItems: "stretch",
		gap: "8px",
		marginTop: "8px"
	}
}));

export const ResultsCount = styled.span(({ theme }) => ({
	marginLeft: "auto",
	fontSize: "12px",
	fontWeight: 400,
	color: theme.project.colors.fontColors.secondary,
	letterSpacing: "0.4px"
}));
